/**
 * External Dependencies
 */
import 'jquery';
import 'jquery-validation/dist/jquery.validate.min.js';
import 'jquery-validation/dist/additional-methods.min.js';
import 'slick-carousel/slick/slick.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
//import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';

// Add all icons to the library so you can use it in your page
library.add(fab, faQuestionCircle, fal);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/**
 * Local Files
 */
import './contactForm.js';
import './applicationForm.js';
import './jquery.fitvids.js';
import './googleMaps.js';

$(document).ready(() => {

  /**
   * Init FitVids
   */
  $('body').fitVids();

  // //Toogle sticky header
  // $(document).on('mousewheel', function(event) {
  //   if (event.originalEvent.wheelDelta >= 0) {
  //     $('.header--scroll').addClass('activate');
  //   } else {
  //     $('.header--scroll').removeClass('activate');
  //   }
  // });

  // $(document).on('touchmove', function() { //touchmove works for iOS, I don't know if Android supports it
  //   $(document).trigger('mousewheel');
  // });

  /**
   * Add class to body when scrolled past the top bar
   */
  var scrolled = function() {
    var height = $('.header--fixed').outerHeight();
    //var height = 20;

    if ($(window).scrollTop() > height) {
      $('.header--scroll').addClass('activate');
    } else {
      $('.header--scroll').removeClass('activate');
    }
  };

  $(window).scroll(function() {
    scrolled();
  });

  /**
   * ScrollTo
   */
  $('a[href*="#"]').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        event.preventDefault()
        $('html,body').animate({
          scrollTop: target.offset().top - $('.header--scroll').outerHeight(),
        }, 1000);

      }
    }
  });

  /**
   * FAQs
   */
  $('.faq__item__open').hide();
  $('.faq__item').on('click', '.faq__item__question', function(e) {
    e.preventDefault();
    $(this)
      .siblings('.faq__item__answer')
      .slideToggle();
    $(this)
      .children('.faq__item__open')
      .toggle();
    $(this)
      .children('.faq__item__closed')
      .toggle();
  });

  /**
   * Toggle Navigation
   */
  function toggleNav() {
    $('body').toggleClass('toggle-nav');
  }

  $('.toggle-nav').on('click', function(e) {
    e.preventDefault;
    $('body').toggleClass('open-nav');
  });

  $('.navbar-toggle').click(function(){ toggleNav(); });

  var navList = jQuery('.mobile-navigation .nav');
  var etOpener = '<span class="open-child">';
  etOpener +=  '<span class="sub-menu-open"><i class="fal fa-plus"></i></span>';
  etOpener += '<span class="sub-menu-close"><i class="fal fa-minus"></i></span>';
  etOpener += '</span>';

  navList.find('li:has(ul) > a',this).each(function() {
    $(this).after(etOpener);
  });

  $('.open-child').click(function() {
    $(this).toggleClass('open');
    $(this).parent().find('.sub-menu').toggleClass('open');
  });

  $('.nav-mobile .sub-menu').hide();
  $('.nav-mobile .sub-menu-close').hide();
  $('.nav-mobile').on('click', '.open-child', function(e) {
    e.preventDefault();
    $(this)
      .siblings('.sub-menu')
      .slideToggle();
    $(this)
      .children('.sub-menu-open')
      .toggle();
    $(this)
      .children('.sub-menu-close')
      .toggle();
  });

  /**
   * Sliders
   */
  $('.slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  /**
   * Modal
   */
  $(document).on('click', '.toggle-modal', function(e) {
    e.preventDefault();

    var target = $(this).data('target');
    $('#' + target).addClass('show');
  });

  $(document).on('click', '.modal-overlay, .modal-overlay .close', function () {
    $('.modal-overlay').removeClass('show');
  });

  $('.modal > div').on('click', function (e) {
    e.stopPropagation();
  });

  /**
   * Cookie consent
   */
  $(document).on('click', '.cookie-consent button', function() {
    $('.cookie-consent').fadeOut();
    $.ajax({
      url: "/app/themes/assureddt/ajax/setcookie.php",
      cache: false,
    });
  });

  $(document).on('click', '.package-page-toggle button', function() {
    let target = $(this).data('target');
    $('.packages-tab').hide();
    $('.' + target).show();

    $('.package-page-toggle button').removeClass('active');
    $(this).addClass('active');
  });

  /**
   * Upgrade Table
   */
  $('.upgrade-table-wrap').hide();
  $(document).on('click', '.toggle-upgrades', function(e) {
    e.preventDefault();
    $('.upgrade-table-wrap').slideToggle();
  });
});
